// @generated by protoc-gen-grpc-gateway-es v0.5.0 with parameter "target=ts,generate_name_parser=true"
// @generated from file userjourney/userjourney.proto (package userjourney, syntax proto3)
/* eslint-disable */

import { RPC } from "../runtime";

/**
 * @generated from message userjourney.UserJourneyAvailableUsersRequest
 */
export type UserJourneyAvailableUsersRequest = {
/**
 * @generated from field: string start_date = 1;
 */
startDate?: string;
/**
 * @generated from field: string end_date = 2;
 */
endDate?: string;
}
;
/**
 * @generated from message userjourney.UserJourneyAvailableUsersResponse
 */
export type UserJourneyAvailableUsersResponse = {
/**
 * @generated from field: repeated string users = 1;
 */
users?: string[];
}
;
/**
 * @generated from message userjourney.UserJourneyRequest
 */
export type UserJourneyRequest = {
/**
 * @generated from field: string user = 1;
 */
user?: string;
/**
 * @generated from field: string start_date = 2;
 */
startDate?: string;
/**
 * @generated from field: string end_date = 3;
 */
endDate?: string;
/**
 * IANA timezone name (e.g. "Asia/Colombo"). The daily buckets in the response follow it, so
 * DST transitions inside the range are handled correctly and the days stay right even when no
 * dates are sent. Falls back to the fixed offset carried by start_date when empty.
 *
 * @generated from field: string timezone = 4;
 */
timezone?: string;
}
;
/**
 * @generated from message userjourney.UserJourneyEventsResponse
 */
export type UserJourneyEventsResponse = {
/**
 * @generated from field: repeated userjourney.UserEvent events = 1;
 */
events?: UserEvent[];
}
;
/**
 * @generated from message userjourney.UserEvent
 */
export type UserEvent = {
/**
 * @generated from field: string date = 1;
 */
date?: string;
/**
 * @generated from field: repeated string times = 2;
 */
times?: string[];
/**
 * @generated from field: string event = 3;
 */
event?: string;
/**
 * @generated from field: string info = 4;
 */
info?: string;
}
;
/**
 * @generated from message userjourney.UserJourneyPlotResponse
 */
export type UserJourneyPlotResponse = {
/**
 * @generated from field: map<string, userjourney.UserJourneyEventList> data = 1;
 */
data?: { [key: string]: UserJourneyEventList };
}
;
/**
 * @generated from message userjourney.UserJourneyEventList
 */
export type UserJourneyEventList = {
/**
 * @generated from field: repeated userjourney.UserJourneyEvent events = 1;
 */
events?: UserJourneyEvent[];
}
;
/**
 * @generated from message userjourney.UserJourneyEvent
 */
export type UserJourneyEvent = {
/**
 * @generated from field: string category = 1;
 */
category?: string;
/**
 * @generated from field: string action = 2;
 */
action?: string;
/**
 * @generated from field: string info = 3;
 */
info?: string;
}
;
/**
 * @generated from rpc userjourney.UserJourneyService.GetUserJourneyEvents
 */
export const UserJourneyService_GetUserJourneyEvents = new RPC<UserJourneyRequest,UserJourneyEventsResponse>("GET", "/getUserJourneyEvents");
/**
 * @generated from rpc userjourney.UserJourneyService.GetUserJourneyPlotData
 */
export const UserJourneyService_GetUserJourneyPlotData = new RPC<UserJourneyRequest,UserJourneyPlotResponse>("GET", "/getUserJourneyPlotData");
/**
 * @generated from rpc userjourney.UserJourneyService.GetUserJourneyAvailableUsers
 */
export const UserJourneyService_GetUserJourneyAvailableUsers = new RPC<UserJourneyAvailableUsersRequest,UserJourneyAvailableUsersResponse>("GET", "/getUserJourneyAvailableUsers");
